import { memo } from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center section-dark">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary"></div>
    </div>
  );
};

export default memo(LoadingSpinner); 